module.exports = __webpack_public_path__ + "img/header_img.ad44a206.png";